export default __webpack_public_path__ + "assets/models/07564b3aeafce9cca7fce8d765fe78b7.glb";